import { Action } from '@ngrx/store';
import { Revista, ContenidoStatus } from 'src/common/contenido';

export enum RevistaActionTypes {
	RevistaPageRequested = '[Revista Component] Revista Page Requested',
	RevistaPageLoaded = '[Revista API] Revista Page Loaded',
	RevistaPageCancelled = '[Revista API] Revista Page Cancelled',
	RevistaPageRight = '[Revista API] Revista Page Right'
}

export class RevistaPageRequested implements Action {
	readonly type: string = RevistaActionTypes.RevistaPageRequested;
	constructor( public payload: { check: boolean } ) {
	}
}

export class RevistaPageLoaded implements Action {
	readonly type: string = RevistaActionTypes.RevistaPageLoaded;
	constructor( public payload: { cleared: boolean, nextPageNum: number, status: ContenidoStatus, revista: Revista[] } ) {
	}
}

export class RevistaPageCancelled implements Action {
	readonly type: string = RevistaActionTypes.RevistaPageCancelled;
	constructor( public payload: { status: ContenidoStatus } ) {
	}
}

export class RevistaPageRight implements Action {
	readonly type: string = RevistaActionTypes.RevistaPageRight;
	constructor() {
	}
}

export type RevistaActions = RevistaPageRequested | RevistaPageLoaded | RevistaPageCancelled | RevistaPageRight;